// ============================================================================
//  Envío al proxy de FormAssembly, una persona por POST.
//
//  enviarPersona()  -> envía UNA persona (usado por el registro individual).
//  enviarGrupo()    -> envía una lista en secuencia (docente + estudiantes),
//                      informando progreso y SIN cortar si una falla.
// ============================================================================
import { FORM_ID, mapPersonaToFA } from "./nauConfig";

const PROXY_BASE = "https://pideapi2025.azurewebsites.net/api/FormAssemblyProxy/submit";
// Endpoint de grupo (procesa en background y escribe en la planilla).
const PROXY_GRUPO = "https://pideapi2025.azurewebsites.net/api/FormAssemblyProxy/submitGrupo";

// Envía una persona. Devuelve { ok, message }.
export async function enviarPersona(persona, { proxyBase = PROXY_BASE, formId = FORM_ID } = {}) {
  const fa = mapPersonaToFA(persona);
  const fd = new FormData();
  Object.entries(fa).forEach(([k, v]) => fd.append(k, v));

  const quien = `${persona.nombre || ""} ${persona.apellido || ""}`.trim() || "(sin nombre)";
  console.log(`📤 Mandando [${persona.rol}] ${quien} → form ${formId}`, fa);

  try {
    const res = await fetch(`${proxyBase}/${formId}`, { method: "POST", body: fd });
    const data = await res.json().catch(() => ({}));
    console.log(`📥 Respuesta del servidor para ${quien}:`, { status: res.status, ...data });
    if (res.ok && data.success) return { ok: true, message: data.message || "OK" };
    return { ok: false, message: data.message || `Error ${res.status}` };
  } catch (err) {
    console.log(`❌ Error de red al enviar ${quien}:`, err.message || err);
    return { ok: false, message: err.message || "Error de red" };
  }
}

// Envía una lista de personas en secuencia. No corta si una falla.
//   personas: array de objetos persona
//   onProgress(idx, total, persona, resultado): callback tras cada envío
// Devuelve un array de resultados: { persona, ok, message, indice }.
export async function enviarGrupo(personas, { proxyBase = PROXY_BASE, formId = FORM_ID, onProgress } = {}) {
  const resultados = [];
  for (let i = 0; i < personas.length; i++) {
    const persona = personas[i];
    const r = await enviarPersona(persona, { proxyBase, formId });
    const resultado = { persona, ok: r.ok, message: r.message, indice: i };
    resultados.push(resultado);
    if (onProgress) onProgress(i + 1, personas.length, persona, resultado);
  }
  return resultados;
}

// Envía TODO el grupo en UNA sola llamada al backend, que procesa por detrás
// y escribe cada resultado en la planilla. Devuelve enseguida (no espera a que
// FormAssembly termine con cada persona).
//   personas: array de objetos persona (ya con rol, centro, ubicación)
//   centroEducativo: string para la planilla
// Devuelve { ok, message, total }.
export async function enviarGrupoBackend(personas, centroEducativo, { grupoUrl = PROXY_GRUPO, formId = FORM_ID } = {}) {
  const payload = {
    centroEducativo: centroEducativo || "",
    personas: personas.map((p) => ({
      nombre: p.nombre || "",
      apellido: p.apellido || "",
      rol: p.rol || "alumno",
      campos: mapPersonaToFA(p), // { tfa_...: valor }
    })),
  };

  console.log(`📤 Enviando grupo de ${payload.personas.length} personas → ${grupoUrl}/${formId}`, payload);

  try {
    const res = await fetch(`${grupoUrl}/${formId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await res.json().catch(() => ({}));
    console.log(`📥 Respuesta del backend (grupo):`, { status: res.status, ...data });
    // 202 Accepted = recibido y procesando en background.
    if ((res.ok || res.status === 202) && data.success) {
      return { ok: true, message: data.message || "Inscripción recibida", total: data.total };
    }
    return { ok: false, message: data.message || `Error ${res.status}` };
  } catch (err) {
    console.log(`❌ Error de red al enviar el grupo:`, err.message || err);
    return { ok: false, message: err.message || "Error de red" };
  }
}

export { PROXY_BASE, PROXY_GRUPO };